import { useMemo } from "react";
import { getJwtRoleSlug } from "../../../public/utils/jwtRole";
import { getStoredAuthRole } from "../../../public/utils/authSession";
import { getAuthItem } from "../../../public/utils/authStorage";
import { useInwardOutwardRolePermissions } from "../hooks/useInwardOutwardRolePermissions";
import {
  buildInwardOutwardPermissions,
  buildInwardOutwardPermissionsForScreen,
} from "./inwardOutwardPermissions";

function resolveRoleSlug() {
  return (
    getJwtRoleSlug(getAuthItem("jwt_token")) ||
    getStoredAuthRole() ||
    ""
  );
}

export function useInwardOutwardRole(screenSlug = null) {
  const sessionRoleSlug = useMemo(() => resolveRoleSlug(), []);

  const {
    permissions,
    roleSlug: apiRoleSlug,
    loading: permissionsLoading,
    error: permissionsError,
  } = useInwardOutwardRolePermissions(Boolean(sessionRoleSlug));

  const roleSlug = apiRoleSlug || sessionRoleSlug;

  const perms = useMemo(() => {
    if (screenSlug) {
      return buildInwardOutwardPermissionsForScreen(permissions, roleSlug, screenSlug);
    }
    return buildInwardOutwardPermissions(permissions);
  }, [permissions, roleSlug, screenSlug]);

  return {
    roleSlug,
    permissionsLoading,
    permissionsError,
    isAdmin: perms.isAdmin,
    canView: perms.canView,
    canCreate: perms.canCreate,
    canEdit: perms.canEdit,
    canDelete: perms.canDelete,
    canManageMasters: perms.canManageMasters,
    canDeleteMasters: perms.canDeleteMasters,
    canExport: perms.canExport,
  };
}
